<template>
  <div class="grid w-full grid-cols-1 gap-8 lg:grid-cols-2">
    <div
      v-for="(tool, index) in tools"
      :key="index"
      class="flex h-full w-full flex-col overflow-hidden rounded-2xl border border-[#eaecf0] bg-[linear-gradient(180deg,_#FCFCFD_0%,_#F9FAFB_100%)] lg:min-h-[400px]"
    >
      <div class="flex flex-col gap-1 p-6">
        <h1 class="text-2xl font-medium text-[#101828]">
          {{ tool.name }}
        </h1>
        <p class="text-base text-[#344054]">
          {{ tool.description }}
        </p>
      </div>
      <img
        :src="tool.image"
        alt="tool-img"
        class="h-40 w-full flex-1 object-cover sm:h-[268px]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from "vue";
import ToolShapes from "@/../images/tabbed-bento-images/tools/shapes.png";
import ToolImages from "@/../images/tabbed-bento-images/tools/images.png";
import ToolTypes from "@/../images/tabbed-bento-images/tools/types.png";
import ToolLayers from "@/../images/tabbed-bento-images/tools/layers.png";

const tools = shallowRef([
  {
    name: "Shapes",
    description: "Simply pick a shape, resize, and watch your design come alive. Because in the world of postcards, shapes speak louder than words!",
    image: ToolShapes,
  },
  {
    name: "Images",
    description: "Stop wasting countless hours searching for the perfect image. Our  image library allows you to quickly find anything you need.",
    image: ToolImages,
  },
  {
    name: "Types",
    description:
      "Experiment with fonts, sizes, and colors to achieve the perfect look every time with our user-friendly editor. Your text, your way!",
    image: ToolTypes,
  },
  {
    name: "Layers",
    description: "Layers provide freedom to experiment with text, images, or shapes. Explore various arrangements to find your perfect balance.",
    image: ToolLayers,
  },
]);
</script>
